import { getAuth } from "firebase/auth";
import { getApiUrl } from "./config";

/**
 * GET /api/lease-compliance/:state
 * Returns { state, securityDepositMonths, depositStatute, disclosures } for Compliance Dashboard.
 */
export async function getLeaseCompliance(state) {
  const s = (state || "").trim().toUpperCase().slice(0, 2);
  if (!s)
    return {
      state: "",
      securityDepositMonths: null,
      depositStatute: null,
      disclosures: [],
    };
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  const res = await fetch(
    `${getApiUrl()}/lease-compliance/${encodeURIComponent(s)}`,
    {
      headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    }
  );
  if (!res.ok) throw new Error("Failed to load lease compliance");
  return res.json();
}

/**
 * GET /api/lease-compliance/:state/validate-deposit?rent=1500&deposit=3000
 * Returns { valid, statute, maxAllowed }.
 */
export async function validateLeaseDeposit(state, rent, deposit) {
  const s = (state || "").trim().toUpperCase().slice(0, 2);
  if (!s) return { valid: true };
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  const params = new URLSearchParams({
    rent: String(rent),
    deposit: String(deposit),
  });
  const res = await fetch(
    `${getApiUrl()}/lease-compliance/${encodeURIComponent(
      s
    )}/validate-deposit?${params}`,
    { headers: { ...(token && { Authorization: `Bearer ${token}` }) } }
  );
  if (!res.ok) return { valid: true };
  return res.json();
}
